<template>
  <el-container id="glUserSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <!--        <p style="font-size:20px;margin-left:20px;font-weight:bold;height:20px;line-height:20px">{{ h_text }}</p>-->
        <el-divider></el-divider>
        <div style="display: flex">
          <div style="width:50%;padding-left:20px;align-content: center">
            <p style="padding:0px;margin-bottom:5px;margin-top:15px">活动封面 (480*852)</p> <!--240*426-->
            <div style="display:flex">
              <el-image :src="imageUrl" style="width:11.7vh;height:20vh">
                <div slot="error" class="image-slot" style="background-color:#F4F4F4;height:100%;width:100%">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div style="position:relative;">
                <el-upload
                    class="avatar-uploader"
                    :action=url_upFile
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"> <!--:http-request="uploadFile"-->
                  <el-button :disabled="noOperate" type="primary" icon="el-icon-upload"
                             style="font-size:15px;line-height:15px;margin-left:5px;position:absolute;bottom: 0;">上传新封面
                  </el-button>
                </el-upload>
              </div>
            </div>
          </div>
          <div style="width:50%">
            <p style="padding:0px;margin-bottom:5px;margin-top:15px">内容顶部图 (750*640)</p> <!--375*320-->
            <div class="image-slot" style="display:flex;">
              <el-image :src="imageUrl1" style="width:24vh;height:20vh">
                <div slot="error" style="background-color:#F4F4F4;height:100%;width:100%">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div style="position:relative;">
                <el-upload
                    class="avatar-uploader"
                    :action=url_upFile
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    :before-upload="beforeAvatarUpload1"><!--:http-request="uploadFile1"-->
                  <el-button :disabled="noOperate" type="primary" icon="el-icon-upload"
                             style="font-size:15px;line-height:15px;margin-left:5px;position:absolute;bottom: 0;">上传顶部图
                  </el-button>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;margin-top:5px;padding-right:35px;">
          <div style="width:50%;padding-left:20px;">
            <p style="margin-top:5px;margin-bottom:5px">活动名称</p>
            <el-input :disabled="noOperate" v-model="ediTitle" maxlength="30" placeholder="请输入名称"
                      style="width:98%"></el-input>
          </div>
          <div style="width:50%;">
            <p style="margin-top:5px;margin-bottom:5px">活动描述</p>
            <el-input :disabled="noOperate" v-model="ediDescription" maxlength="20" placeholder="请输入描述"
                      style="width:100%"></el-input>
          </div>
          <!--          <div style="width:50%;padding-left:0px;">-->
          <!--            <p style="margin-top:5px;margin-bottom:5px">置顶活动</p>-->
          <!--            <el-checkbox :disabled="noOperate" v-model="isTop" style="margin-left:0px;font-size:20px">将此活动置顶显示-->
          <!--            </el-checkbox>-->
          <!--          </div>-->
        </div>
        <div style="display:flex;margin-top:5px">
          <div style="width:35%;padding-left:20px;">
            <p style="margin-top:5px;margin-bottom:5px">报名截止时间</p>
            <el-date-picker
                v-model="ediApplyEnd"
                style="width:95%"
                :disabled="noOperate"
                type="datetime"
                placeholder="选择日期时间"
                default-time="00:00:00">
            </el-date-picker>
          </div>
          <div style="width:35%;">
            <p style="margin-top:5px;margin-bottom:5px">活动开始时间</p>
            <el-date-picker
                v-model="ediValidStart"
                style="width:95%"
                :disabled="noOperate"
                type="datetime"
                placeholder="选择日期时间"
                default-time="00:00:00">
            </el-date-picker>
          </div>
          <div style="width:35%;">
            <p style="margin-top:5px;margin-bottom:5px">活动结束时间</p>
            <el-date-picker
                v-model="ediValidEnd"
                style="width:95%"
                :disabled="noOperate"
                type="datetime"
                placeholder="选择日期时间"
                default-time="00:00:00">
            </el-date-picker>
          </div>
        </div>
        <div style="display:flex;margin-top:5px">
          <div style="width:50%;padding-left:20px;">
            <p style="margin-top:5px;margin-bottom:5px">最多参加人数</p>
            <el-input-number :disabled="noOperate" v-model="ediMaxApplys" placeholder="请输入人数"
                             style="width:98%" :min="1" :step="1"></el-input-number>
          </div>
          <div style="width:50%;padding-left:0px;">
            <p style="margin-top:5px;margin-bottom:5px">报名限制</p>
            <el-checkbox :disabled="noOperate" v-model="onlyOwer" style="margin-left:0px;font-size:20px">仅限业主报名
            </el-checkbox>
          </div>
        </div>
        <div style="margin-top:5px;padding-left:20px;">
          <p style="margin-top:5px;margin-bottom:5px">副标题</p>
          <textarea :disabled="noOperate" v-model="ediDetail" maxlength="30"
                    style="width:98%;height:10vh"></textarea>
        </div>
        <div style="display:flex;width:98%">
          <el-button v-if="!noOperate" style="margin-left:auto;margin-right:1px;height:40px" type="info"
                     @click="onBack"
                     icon="el-icon-close">取消
          </el-button>
          <el-button v-if="noOperate"
                     style="margin-right:1px;height:40px;margin-left:auto;" @click="onBack" type="info"
                     icon="el-icon-back">返回
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(2)" icon="el-icon-s-promotion"
                     style="height: 40px">发布
          </el-button>
          <el-button v-if="!noOperate" type="primary" @click="onKeep(1)" style="height: 40px">保存草稿
          </el-button>
        </div>
      </el-main>
    </el-container>
    <!--    <el-dialog-->
    <!--        append-to-body-->
    <!--        title="图片裁剪"-->
    <!--        ref="dialog"-->
    <!--        width="375"-->
    <!--        class="img-cropper"-->
    <!--        :visible.sync="dialogVisible"-->
    <!--        :close-on-click-modal="false">-->
    <!--      <div class="cropper-w">-->
    <!--        <div class="cropper" :style="{ width: img_w, height: img_h }">-->
    <!--          <vueCropper-->
    <!--              ref="cropper"-->
    <!--              :img="option.img"-->
    <!--              :outputSize="option.size"-->
    <!--              :outputType="option.outputType"-->
    <!--              :info="option.info"-->
    <!--              :full="option.full"-->
    <!--              :canMove="option.canMove"-->
    <!--              :canMoveBox="option.canMoveBox"-->
    <!--              :original="option.original"-->
    <!--              :autoCrop="option.autoCrop"-->
    <!--              :autoCropWidth="option.autoCropWidth"-->
    <!--              :autoCropHeight="option.autoCropHeight"-->
    <!--              :fixedBox="option.fixedBox">-->
    <!--          </vueCropper>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
    <!--        <el-button type="primary" @click="finish">确认</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <el-dialog top="2vh" width="60vw" title="图片裁剪" :show-close="true"
               :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="cropper-w" style="margin:0">
        <div class="cropper" :style="{textAlign:'center',height: img_h }">
          <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="option.info"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixedBox="option.fixedBox">
          </vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from 'axios';
import vueCropper from '../views/vueCropper.vue';

export default {
  name:"glUserSon",
  components:{
    vueCropper
  },
  data() {
    return {
      h_text:"新增活动",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""},
        {"text":"活动管理","colour":"#B7B7B7","pages":""}
      ],
      img_w:"375px",
      img_h:"75vh",
      upImg:0,
      dialogVisible:false,
      page:1,
      pageSize:10,
      total:0,
      noOperate:true,
      edi_auth:"",
      li_auth:[],
      authPage:1,
      authPageSize:10,
      authTotal:10,
      zhName:"",
      password:"",
      nickName:"", /*账号*/
      value3:"",
      imageUrl:"",
      imageUrl1:"",
      imageId:-1,
      imageId1:-1,
      url_upFile:"",
      ediTitle:"", /*活动名称*/
      ediDescription:"", /*活动描述*/
      ediDetail:"", /*活动详情*/
      ediApplyStart:"", /*报名开始时间*/
      ediApplyEnd:"", /*报名结束时间*/
      ediValidStart:"", /*活动开始时间*/
      ediValidEnd:"", /*活动结束时间*/
      ediMaxApplys:"", /*最大报名个数*/
      ImageUrl:[], /*活动宣传图片*/
      CoverFile:"", /*活动封面图片*/
      CoverFileId:"", /*活动封面图片id*/
      sort:"", /*排序*/
      stateId:1, /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
      id:"",
      isCtr:true, /*是否能操作*/
      isTop:false, /*是否置顶*/
      onlyOwer:false, /*是否开启报名限制*/
      option:{
        img:"", // 裁剪图片的地址
        info:true, // 裁剪框的大小信息
        outputSize:0.8, // 裁剪生成图片的质量
        outputType:"jpeg", // 裁剪生成图片的格式
        canScale:false, // 图片是否允许滚轮缩放
        autoCrop:true, // 是否默认生成截图框
        autoCropWidth:375, // 默认生成截图框宽度
        autoCropHeight:562, // 默认生成截图框高度
        fixedBox:false, // 固定截图框大小 不允许改变
        fixed:false, // 是否开启截图框宽高固定比例
        fixedNumber:[
          7,
          5
        ], // 截图框的宽高比例
        full:true, // 是否输出原图比例的截图
        canMoveBox:true, // 截图框能否拖动
        original:true, // 上传图片按照原始比例渲染
        centerBox:true, // 截图框是否被限制在图片里面
        infoTrue:true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    onKeep(stateId) {
      // console.log(this.ediApplyEnd.getTime()) /*时间转秒*/
      // console.log(this.ediValidStart.getTime())
      // console.log(this.ediValidEnd.getTime())
      // console.log(this.timestampToTime(this.ediApplyEnd.getTime() / 1000)) /*秒转时间*/
      let toDay = new Date().getTime();
      if (!this.ediApplyEnd) {
        this.$message.info('请先选择报名截止时间');
        return;
      } else if (!(this.ediValidStart || this.ediValidEnd)) {
        this.$message.info('请先选择活动时间');
        return;
      } else if (this.ediValidEnd.getTime() < toDay) {
        this.$message.info('活动结束时间不能小于当前时间');
        return;
      } else if (this.ediApplyEnd.getTime() > this.ediValidStart.getTime()) {
        this.$message.info('报名截止时间不能大于活动开始时间');
        return;
      } else if (this.ediValidStart.getTime() >= this.ediValidEnd.getTime()) {
        this.$message.info('活动开始时间应早于活动结束时间');
        return;
      } else if (!this.ediMaxApplys) {
        this.$message.info('请输入正确的参加人数');
        return;
      } else if (!(this.imageUrl)) {
        this.$message.info('请先选择封面图');
        return;
      } else if (!(this.imageUrl1)) {
        this.$message.info('请先选择顶部图');
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增活动') {
          this.addActivity(stateId);
        } else {
          this.changeActivity(stateId);
        }
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    beforeAvatarUpload(file) {
      console.log(file.type); /*240*426*/
      //this.img_w = "240px";
      //this.img_h = "426px";
      this.upImg = 0;
      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = '';
      image.onload = function () {
        let base64 = self.transBase64FromImage(image);
        self.option.img = base64;
      };
      this.dialogVisible = true;

      //const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      //
      //if (!isJPG) {
      //  this.$message.error('只能上传png/jpg格式的图片');
      //  return false;
      //}
      //if (!isLt2M) {
      //  this.$message.error('上传头像图片大小不能超过 2MB!');
      //  return false;
      //}
      //return true; // 如果校验通过，返回true继续上传流程
    },
    beforeAvatarUpload1(file) {
      this.upImg = 1;
      console.log(file.type);
      //this.img_w = "375px";  /*375*320*/
      //this.img_h = "320px";
      // 图片转为base64
      let self = this;
      const _URL = window.URL || window.webkitURL;
      const image = new Image();
      image.src = _URL.createObjectURL(file);
      self.option.img = '';
      image.onload = function () {
        let base64 = self.transBase64FromImage(image);
        self.option.img = base64;
      };
      this.dialogVisible = true;

      //const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      //
      //if (!isJPG) {
      //  this.$message.error('只能上传png/jpg格式的图片');
      //  return false;
      //}
      //if (!isLt2M) {
      //  this.$message.error('上传头像图片大小不能超过 2MB!');
      //  return false;
      //}
      //return true; // 如果校验通过，返回true继续上传流程
    },
    // 将网络图片转换成base64格式
    transBase64FromImage(image) {
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image,0,0,image.width,image.height);
      // 可选其他值 image/jpeg
      return canvas.toDataURL("image/png");
    },
    // base64转成files
    transformToFiles(dataurl,filename) {
      var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr],filename,{type:mime});
    },
    handleSuccess({data:url,code,msg},{name}) {
      if (code !== 200) {
        this.$message.error(msg);
      } else {
        this.$emit('handleFile',[{url,name}]);
      }
    },
    clearFile() {
      this.$emit('removeImage');
      this.$emit('handleFile',[]);
    },
    finish() {
      let _this = this;
      this.$refs.cropper.getCropBlob(async(data) => {
        let formData = new FormData();
        console.log(data);
        if (data) {
          var timestamp = new Date().getTime() + '.jpg';
          //  将blob格式转换为文件。File() 构造器创建新的 File 对象实例。
          const newFile = new window.File([data],timestamp);

          formData.append('file',newFile);
          formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
          // 设置请求头
          const config = {
            headers:{
              'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
              'token':localStorage.getItem("token")
            }
          };
          console.log(this.$urls.ip + this.$urls.uploadFile);
          // 使用axios或其他HTTP客户端发送请求
          if (this.upImg === 0) {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
                .then(response => {
                  console.log(response.data);
                  this.imageId = response.data.data.id;
                  this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
                  this.dialogVisible = false;
                }).catch(error => {
              console.log(error);
              if (error) {
                this.$message.error("上传失败");
              }
            });
          } else {
            axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
                .then(response => {
                  console.log(response.data);
                  this.imageId1 = response.data.data.id;
                  this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
                  this.dialogVisible = false;
                }).catch(error => {
              console.log(error);
              if (error) {
                this.$message.error("上传失败");
              }
            });
          }
        } else {
          this.$message.warning('请重新截图');
        }
      });
      _this.$forceUpdate();
    },
    uploadFile(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId = response.data.data.id;
            this.imageUrl = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess1(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    uploadFile1(content) {
      let formData = new FormData();
      formData.append('file',content.file); // 假设你的后端需要名为'file'的字段接收文件
      formData.append('projectId',localStorage.getItem("projectId")); // 假设你的后端需要名为'file'的字段接收文件
      // 设置请求头
      const config = {
        headers:{
          'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
          'token':localStorage.getItem("token")
        }
      };
      console.log(this.$urls.ip + this.$urls.uploadFile);
      // 使用axios或其他HTTP客户端发送请求
      axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
          .then(response => {
            console.log(response.data);
            this.imageId1 = response.data.data.id;
            this.imageUrl1 = this.$urls.ip + "/" + response.data.data.url;
          }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("上传失败");
        }
      });
    },
    handleAvatarSuccess(response) {
      console.log(response);
      // this.imageUrl = URL.createObjectURL(response.data.data.url);
    },
    addActivity(stateId) {
      const params = {
        'applyEnd':this.ediApplyEnd.getTime() / 1000,
        'validStart':this.ediValidStart.getTime() / 1000,
        'validEnd':this.ediValidEnd.getTime() / 1000,
        'title':this.ediTitle,
        'description':this.ediDescription,
        'detail':this.ediDetail,
        'maxApplys':this.ediMaxApplys,
        'top':this.isTop,
        'onlyOwer':this.onlyOwer,
        'coverFileId':this.imageId,
        'CoverFile':{id:this.imageId,'projectId':localStorage.getItem("projectId")},
        'ImageUrl':[{id:this.imageId1,'projectId':localStorage.getItem("projectId")}],
        'stateId':stateId,
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newActivity,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    changeActivity(stateId) {
      const params = {
        'id':this.id,
        'applyEnd':this.ediApplyEnd.getTime() / 1000,
        'validStart':this.ediValidStart.getTime() / 1000,
        'validEnd':this.ediValidEnd.getTime() / 1000,
        'title':this.ediTitle,
        'description':this.ediDescription,
        'detail':this.ediDetail,
        'maxApplys':this.ediMaxApplys,
        'top':this.isTop,
        'onlyOwer':this.onlyOwer,
        'coverFileId':this.imageId, /*封面*/
        'CoverFile':{id:this.imageId,'projectId':localStorage.getItem("projectId")},
        'ImageUrl':[{id:this.imageId1,'projectId':localStorage.getItem("projectId")}],
        'stateId':stateId,
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateActivity,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.replaceActivityImages();
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    replaceActivityImages() {
      const params = {
        'activityId':this.id,
        'fileIds':[this.imageId1],
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.replaceActivityImages,params,headers).then(res => {
        console.log(res.data.data);
        // this.$message.success("修改成功");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getActivity(id) {
      const params = {
        'id':id,
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getActivityList,params,headers).then(res => {
        console.log("getActivityListSon：",res.data.data);
        this.li_user = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取活动数据失败");
        }
      });
    },
    init_View() {
      if (this.li_user.length > 0) {
        let d = this.li_user[0];
        console.log(d["imageUrl"]);
        this.ediTitle = d["title"];
        this.ediDescription = d["description"];
        this.isTop = d["top"];
        this.onlyOwer = d["onlyOwer"];
        this.ediApplyEnd = new Date(d["applyEnd"] * 1000); /*报名截止时间*/
        this.ediValidStart = new Date(d["validStart"] * 1000); /*活动开始时间*/
        this.ediValidEnd = new Date(d["validEnd"] * 1000); /*活动结束时间*/
        this.ediMaxApplys = d["maxApplys"]; /*活动结束时间*/
        this.ediDetail = d["detail"]; /*活动详情*/
        if (d["coverFile"]) { /*封面*/
          this.imageId = d["coverFile"]["id"];
          this.imageUrl = `${this.$urls.ip}/${d["coverFile"]["url"]}`;
        }
        if (d["imageUrl"]) {
          this.imageId1 = d["imageUrl"][0]["id"];
          this.imageUrl1 = `${this.$urls.ip}/${d["imageUrl"][0]["url"]}`;
        }
      }
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(this.noOperate);
    if (value === "addActivity") {
      this.h_text = "新增活动";
      this.noOperate = false;
    } else {
      this.id = parseInt(this.$route.query.id);
      if (this.$route.query.operate === 'w') {
        this.noOperate = false;
        this.h_text = "修改活动信息";
      } else {
        this.noOperate = true;
        this.h_text = "查看活动信息";
      }
      this.getActivity(this.id);
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glUserSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/ActivityGlSon.vue